define([
	"dojo/_base/declare",
	"csi/heading/TimeDateTime",
	"csi/types",
	"csi/xml"
], function(declare,TimeDateTime,types,xml) {
	
	var	_openStates = {
		"DRAFT": 1,
		"PENDING": 1,
		"PENDING2": 1,
		"REVIEW": 1,
		"SUBMITTED": 1	// What is this???
	};
	
	return declare(TimeDateTime, {
		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: restrict filtering for heading
			return null;
		},

		/**
		 * @override
		 * Return time based on current state
		 */
		_getValue: function(ctx, h) {
			const node = ctx.getNode();
			const state = node && xml.enumGetText(node.State);
			
			if (_openStates[state]) {
				return types.getDateTime();
			}
			
			return this.inherited(arguments);
		}
	});
});